/**
 * 统一的能力调用结果。
 *
 * 为什么不是 boolean / 不是 throw：PWA 的能力有**七种不同的失败方式**，而它们对
 * 用户的含义完全不同——「这个浏览器没有」和「你拒绝过通知」和「你得先加到主屏幕」
 * 需要三种不同的界面文案。返回 boolean 的 API 会让每个项目重新发明一遍这个区分，
 * 而漏掉的那个分支就是用户看到「点了没反应」的地方。
 */
export function ok(value) {
    return { ok: true, value };
}
export function fail(reason, detail) {
    return detail === undefined ? { ok: false, reason } : { ok: false, reason, detail };
}
export function isOk(r) {
    return r.ok;
}
export function unwrapOr(r, fallback) {
    return r.ok ? r.value : fallback;
}
/** 把任意抛出物收成 Fail，不让一个未处理的 rejection 变成「静默什么都没发生」。 */
export function failFrom(reason, e) {
    const detail = e instanceof Error ? e.message : String(e);
    return fail(reason, detail);
}
/** 人类可读的失败说明。UI 可以直接用，也可以只拿它做兜底。 */
export const FAILURE_TEXT = {
    unsupported: { zh: '当前浏览器不支持这个功能', en: 'This browser does not support the feature' },
    'not-installed': { zh: '需要先把应用添加到主屏幕，并从主屏图标打开', en: 'Add the app to your Home Screen and open it from there first' },
    'permission-denied': { zh: '权限已被拒绝，需要到系统设置里重新打开', en: 'Permission was denied; re-enable it in system settings' },
    'permission-default': { zh: '还没有授权', en: 'Permission has not been requested yet' },
    'requires-user-gesture': { zh: '需要在你点击的那一下里发起', en: 'Must be triggered directly by a user action' },
    'insecure-context': { zh: '需要 HTTPS 环境', en: 'Requires a secure (HTTPS) context' },
    'no-service-worker': { zh: 'Service Worker 尚未就绪', en: 'Service Worker is not ready yet' },
    'platform-restriction': { zh: '当前平台不提供这个能力', en: 'This platform does not offer the capability' },
    failed: { zh: '操作失败', en: 'The operation failed' },
};
//# sourceMappingURL=result.js.map